import axios from "axios";

export class GetWhiteBrandColors {
  constructor(
    private readonly frontend
  ) {}

  async run(domain: string) {
    const args = {
      domain: domain,
    }
    const response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/get_white_brand_colors/', { params: args })
    if (response.data.colors) {
      // Apply colors to Vuetify theme
      const colors = response.data.colors
      Object.keys(colors).forEach(key => {
        if (this.frontend.$vuetify.theme.themes.light[key] !== undefined) {
          this.frontend.$vuetify.theme.themes.light[key] = colors[key]
        }
      })
      this.frontend.whiteBrandColors = colors
    }
  }
}
